import React from 'react';
import { FieldTemplateProps } from '@rjsf/utils';
import { Box } from '@mui/material';

export const CustomFieldTemplate = (props: FieldTemplateProps) => {
  const { id, classNames, style, description, errors, children, formContext } = props;

  // Get gap from formContext, default to 1rem if not provided
  const gap = formContext?.gap || '1rem';

  return (
    <Box
      id={id}
      className={classNames}
      style={style}
      sx={{ marginBottom: gap, minWidth: 0 }}>
      {children}
      {description}
      {errors}
    </Box>
  );
};
